import { useQuery } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';

import { searchTerm } from '../../recoil/searchTerm';
import { useQueryDebounce } from '../useQueryDebounce';
import { useEnvContext } from '../../../../../modules/EnvProvider';
import { fetchSearchOffers } from '../../../../api/search';

const useSearchOffers = () => {
  const searchKeyword = useRecoilValue(searchTerm);
  const debounceTerm = useQueryDebounce(searchKeyword, 300);
  const { targetEnv } = useEnvContext();

  const { data, ...options } = useQuery(
    ['fetchSearchOffers', { debounceTerm }],
    () => fetchSearchOffers(debounceTerm, targetEnv, { isWebView: false }),
    {
      enabled: !!debounceTerm,
    }
  );

  return { data: data?.data?.data, ...options };
};

export default useSearchOffers;
